export default __webpack_public_path__ + "static/media/tibolli.9bab6ba5.JPG";